module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-row",
    staticStyle: {
      "height": "calc(100% - 28px)"
    }
  }, [_c('div', {
    staticClass: "alarm_remind "
  }, [_c('div', {
    staticClass: "vehicle_alarm",
    class: {
      open: _vm.curAlarmType == 1
    },
    on: {
      "click": function($event) {
        return _vm.toShowAlarm(1)
      }
    }
  }, [_c('vehicle-alarm-emg', {
    attrs: {
      "emgNum": _vm.alarmEmgNum
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vehicle_alarm",
    class: {
      open: _vm.curAlarmType == 2
    },
    on: {
      "click": function($event) {
        return _vm.toShowAlarm(2)
      }
    }
  }, [_c('vehicle-alarm-ord', {
    attrs: {
      "ordNum": _vm.alarmEmgOrd
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vehicle_alarm",
    class: {
      open: _vm.curAlarmType == 3
    },
    on: {
      "click": function($event) {
        return _vm.toShowAlarm(3)
      }
    }
  }, [_c('vehicle-alarm-gen', {
    attrs: {
      "genNum": _vm.alarmEmgGen
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "track_bottom_btn"
  }, [(_vm.permission.indexOf('monitorVehicle_alarmPanelDetailList') == -1) ? _c('i', {
    on: {
      "click": _vm.addTab
    }
  }, [_c('a', {
    staticClass: "ico_02"
  }, [_vm._v("预警一览")])]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.refreshAlm
    }
  }, [_vm._v("刷新")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f58c82c","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehiclemonitor/menumaptabs/VehicleAlarm.vue
// module id = 1537
// module chunks = 0